// The backend returns 401 with { error: { code: 'unauthorized', ... } }
// whenever the session token is missing, invalid, or expired
export const SESSION_EXPIRED_MESSAGE =
  'Your session has expired. Please log in again.';

export function isAuthError(error) {
  return (
    typeof error === 'object' &&
    error !== null &&
    error.status === 401
  );
}
